import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../../services/api';

const EsqueciSenha: React.FC = () => {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (enviando) return;

    setEnviando(true);
    setErro('');

    try {
      await apiService.post('/auth/forgot-password', { email });
      // A API responde igual existindo ou não o e-mail, para não virar oráculo de
      // contas cadastradas. A tela mantém esse comportamento.
      setEnviado(true);
    } catch (err: any) {
      setErro(err.response?.data?.message || 'Não foi possível processar a solicitação. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  if (enviado) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
        <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-lg shadow">
          <h1 className="text-2xl font-bold text-gray-900">Verifique seu e-mail</h1>
          <p className="text-gray-600">
            Se <span className="font-medium">{email}</span> estiver cadastrado, enviamos um link para
            você criar uma nova senha. O link vale por 60 minutos.
          </p>
          <p className="text-sm text-gray-500">
            Não recebeu? Confira a caixa de spam ou{' '}
            <button
              type="button"
              onClick={() => setEnviado(false)}
              className="text-blue-600 hover:underline"
            >
              tente novamente
            </button>
            .
          </p>
          <Link to="/login" className="block text-center text-blue-600 hover:underline">
            Voltar para o login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <form onSubmit={handleSubmit} className="max-w-md w-full space-y-6 bg-white p-8 rounded-lg shadow">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Esqueci minha senha</h1>
          <p className="text-gray-600 mt-2">
            Informe o e-mail da sua conta e enviaremos um link para criar uma nova senha.
          </p>
        </div>

        {erro && (
          <div role="alert" className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
            {erro}
          </div>
        )}

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            E-mail
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="seu@email.com.br"
          />
        </div>

        <button
          type="submit"
          disabled={enviando}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {enviando ? 'Enviando...' : 'Enviar link de recuperação'}
        </button>

        <Link to="/login" className="block text-center text-blue-600 hover:underline">
          Voltar para o login
        </Link>
      </form>
    </div>
  );
};

export default EsqueciSenha;
